import addError from '../../../utils/error.jsx';

export function request(id, eventId) {
    return {
        type: 'MARKETS_SETTLE_REQUEST',
        eventId,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'MARKETS_SETTLE_ERROR',
        errors,
        id
    };
}

export function finish(id, market) {
    return {
        type: 'MARKETS_SETTLE_FINISH',
        market,
        id
    };
}
